var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-col',{staticClass:"app",attrs:{"id":"app"}},[_c('m-transition',[(_vm.isNavigationVisible)?_c('the-navigation'):_vm._e()],1),_c('m-transition',[_c('router-view')],1),(_vm.$isDev)?_c('span',{staticClass:"app__version"},[_vm._v(_vm._s(_vm.$appVersion))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }